import { ApolloClient } from '@apollo/client';

import { GetRoleClaimsQuery, GetRoleClaimsQueryVariables } from '../../../types';
import { GET_ROLE_CLAIMS } from './getRoleClaims';

// Imperative helper to fetch a user's full role claims from the GQL service.
// Use this from non-React code (e.g. User.oauthCallback) where hooks aren't
// available. Returns the compressed role string in the same base64+gzip
// format as the JWT user_role_v4 claim.
export const fetchRoleClaims = async (client: ApolloClient<unknown>, userId: string): Promise<string | null> => {
  try {
    const { data } = await client.query<GetRoleClaimsQuery, GetRoleClaimsQueryVariables>({
      query: GET_ROLE_CLAIMS,
      variables: { userId },
      fetchPolicy: 'no-cache',
    });
    return data?.getRoleClaims?.compressedRoles ?? null;
  } catch (error) {
    console.error('Failed to fetch role claims', error);
    return null;
  }
};
